export const HALF_YEAR_IN_MONTHS_AS_NUMBER = 6;

export const HALF_YEAR_IN_MONTHS_AS_STRING =
  HALF_YEAR_IN_MONTHS_AS_NUMBER.toString();
